import { useMutation } from "@tanstack/react-query";
import api from "apis";
import { DocumentApprovalRequest } from "apis/data-contracts";

interface RequestApprovalParams {
  documentUuid: string;
  data: DocumentApprovalRequest;
}

export const useRequestApprovalMutation = () => {
  return useMutation({
    mutationFn: ({ documentUuid, data }: RequestApprovalParams) =>
      api.document.requestApproval(documentUuid, data),
  });
};
